import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { APP_BRANDING_PENDING, type IAppBranding } from '@/constants/app-branding';

interface IAppBrandingState {
    branding: IAppBranding;
}

interface IAppBrandingActions {
    hydrate: (branding: IAppBranding) => void;
}

export const useAppBrandingStore = create<IAppBrandingState & IAppBrandingActions>()(
    immer(set => ({
        branding: { ...APP_BRANDING_PENDING },
        hydrate: branding =>
            set(state => {
                state.branding = branding;
            }),
    }))
);
